/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ApiSearchOptimizedRetrievePetType =
  (typeof ApiSearchOptimizedRetrievePetType)[keyof typeof ApiSearchOptimizedRetrievePetType];

export const ApiSearchOptimizedRetrievePetType = {
  dog: 'dog',
  cat: 'cat',
} as const;
